/**
 * Feature param values for med plans. Used in the `feature` URL parameter
 * for clinical flow routing (e.g. insurance checker → clinical, paid campaigns).
 * Consumed by features.ts and planInformation recommendation logic.
 */
export const FEATURE_PARAM = {
  BRANDED: "branded",
  COMPOUNDED: "compounded",
  MICRODOSE: "microdose",
  MICRODOSE_PROACTIVE_HEALTH: "microdoseProactiveHealth",
  ORALS: "orals",
} as const;
